import { render } from "./UserPopup.vue?vue&type=template&id=05278214"
import script from "./UserPopup.vue?vue&type=script&lang=js"
export * from "./UserPopup.vue?vue&type=script&lang=js"

import "./UserPopup.vue?vue&type=style&index=0&id=05278214&lang=css"
script.render = render

export default script